$(document).ready(function () {
    $('a.back').on('click', function () {
        parent.history.back();
        return false;
    });
});